/*global config*/
import React from 'react';
import ReactDOM from 'react-dom';
import 'intro.js/introjs.css';
import Loadable from 'react-loadable';
import Loader from './common/Loader';
import ErrorBoundary from './util/ErrorBoundary';
import AcademicYear from './common/AcademicYear';

function sleep( ms ) {
	return new Promise(resolve => setTimeout(resolve, ms));
}

async function waitUntilConfigIsReady() {
	if ( typeof config == 'undefined' ) {
    	for (let i = 1; i < 20 ; i++) { 
    		if ( typeof config == 'undefined' ) {
    			await sleep( 500 );
    		} else {
    			return;
    		}
    	}
	}
	return;
}

async function mount(componentImport, element, props = {}, customStyles = '') {
	await waitUntilConfigIsReady();
	
	const DynamicComponent = Loadable({
		loader: () => import(`${componentImport}.jsx`),
		loading: () => <Loader customStyles={customStyles} />,
	});

	const Wrapper = (<ErrorBoundary><DynamicComponent {...props} /></ErrorBoundary>);

	ReactDOM.render(Wrapper, document.getElementById(element));
}

function unmount(element) {
	// not used?
}

export {
	mount,
	unmount,
	AcademicYear,
};
